/** 服务专页 · 快捷呼叫选项 */
export const SERVICE_QUICK_BUTTONS = [
  '加热水',
  '收拾桌面',
  '帮忙拍照',
  '加餐具',
  '清理垃圾',
  '呼叫经理',
];

export const SERVICE_MAIN_CALL_MESSAGE = '呼叫服务';
